// @flow
const getContactHref = (name: string, contact: string) => {
  let href;

  switch (name) {
    case 'email':
      href = `mailto:${contact}`;
      break;
    case 'instagram':
      href = `https://www.instagram.com/${contact}`;
      break;
    case 'pinterest':
      href = `https://www.pinterest.com/${contact}`;
      break;
    case 'facebook':
      href = `https://www.facebook.com/${contact}`;
      break;
    default:
      href = contact;
      break;
  }

  return href;
};

export default getContactHref;
